import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import { THEME_COLORS } from "../../../../../color";

const DonutChart = ({
  width = 420, // Fixed consistent width
  height = 420, // Fixed consistent height
  colors = [THEME_COLORS.green, THEME_COLORS.yellow, THEME_COLORS.darkblue],

  data = [],
  options = {},
  icon = null,
  title = "",
  para = "",
  totalValue,
}) => {
  const labels = useMemo(() => data.map((item) => item.name), [data]);
  const values = useMemo(() => data.map((item) => item.value), [data]);

  const totalSum = useMemo(() => {
    return values.reduce((a, b) => a + (b || 0), 0);
  }, [values]);

  const isZero = totalSum === 0;

  const chartSeries = useMemo(() => {
    return isZero ? values.map(() => 1) : values;
  }, [isZero, values]);

  const fOptions = {
    chart: {
      type: "donut",
      width: width,
      height: height,
    },
    labels,
    colors,
    dataLabels: {
      enabled: isZero ? false : true,
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: "20px",
        fontWeight: 800,
        colors: ["#00000"],
      },
      dropShadow: {
        enabled: false,
      },
    },
    legend: {
      show: true,
      position: "right",
      width: 130,
      offsetY: 0,
      fontSize: "12px",
      fontWeight: 700,
      itemMargin: {
        horizontal: 10,
        vertical: 8,
      },
      markers: {
        size: 12,
        shape: "square",
        strokeWidth: 1,
      },
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        expandOnClick: isZero ? false : true,
        donut: {
          size: "65%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "11px",
              fontWeight: 600,
              color: "#333",
              offsetY: -4,
              formatter: (val) => {
                if (val && val.length > 10) return val;
                return val;
              },
            },
            value: {
              show: true,
              fontSize: "16px",
              fontWeight: 700,
              offsetY: 4,
              formatter: (val) => (isZero ? 0 : val),
            },
            total: {
              show: true,
              label: "Total",
              fontSize: "11px",
              fontWeight: 600,
              formatter: () =>
                totalValue !== undefined ? totalValue : isZero ? 0 : 100,
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          chart: { width: 350, height: 350 },
          legend: {
            position: "bottom",
            offsetY: 10,
          },
          dataLabels: {
            style: {
              fontSize: "14px",
            },
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: { width: 280, height: 280 },
          legend: {
            position: "bottom",
            offsetY: 5,
            fontSize: "10px",
          },
          dataLabels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      },
    ],
    tooltip: {
      y: {
        formatter: (val) => (isZero ? "0" : val),
      },
    },
    states: {
      hover: { filter: { type: "none" } },
      active: { filter: { type: "none" } },
    },
    ...options,
  };

  return (
    <div className="w-full">
      <div className="flex gap-x-4 items-center mb-2">
        <div className="p-1">{icon}</div>
        <h2
          className="text-[1.15rem] font-bold font-calibri leading-6"
          style={{ color: THEME_COLORS.green }}
        >
          {title}
        </h2>
      </div>

      {/* {para && (
        <div className="ml-12 mb-4">
          <h5 className="text-[1rem] font-medium text-gray-700">{para}</h5>
        </div>
      )} */}
      <div className="flex justify-center items-center">
        <Chart
          type="donut"
          series={chartSeries}
          width={width}
          height={height}
          options={fOptions}
        />
      </div>
    </div>
  );
};

export default DonutChart;
